import type {
	CreateIssueBodyFields,
	CreateIssueBodyIssueLinkType,
	JiraProject,
} from '../__types__/apiUtils';
import type {
	AdditionalIssueField,
	IssueObject,
	IssueType,
} from '../providers/BulkCreateContextProvider';

export const getCreateIssueBodyFields = ({
	issue,
	issueType,
	project,
}: {
	issue: IssueObject;
	issueType: IssueType;
	project: JiraProject;
}): CreateIssueBodyFields => {
	const createFields: CreateIssueBodyFields = {
		description: issue.description,
		issuetype: { id: issueType.id },
		project: { id: project.id },
		summary: issue.summary,
		...(issue.assigneeUserId && { assignee: { id: issue.assigneeUserId } }),
		...(issue.parentIssueLink && {
			parent: {
				key: issue.parentIssueLink,
				id: issue.parentIssueLink,
			} as CreateIssueBodyIssueLinkType,
		}),
		...(issue.labels && { labels: issue.labels }),
		...(issue.parent && {
			parent: { key: issue.parent.key, id: issue.parent.id } as CreateIssueBodyIssueLinkType,
		}),
	};

	if (issue.additionalFields) {
		issue.additionalFields.forEach((f: AdditionalIssueField) => {
			createFields[f.field.fieldId] = f.value;
		});
	}

	return createFields;
};
